<template v-if="visible == true">
  <div class="instruction-modal">
    <div class="modal-backdrop">
      <div class="modal">
        <div class="close-instruction">
          <img
            class="info-btn"
            src="@/assets/close-icon.svg"
            @click="closeModal('close')"
          />
        </div>
        <h1>{{ copy.instructionHeader }}</h1>
        <p>{{ copy.instructionIntroText }}</p>
        <ul>
          <li v-for="point in copy.points" :key="point">{{ point }}</li>
        </ul>
        <p>{{ copy.instructionDisclaimer }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main.js";

export default {
  name: "InstructionModal",
  props: {
    copy: Object,
    language: String,
    isModalVisible: Boolean,
  },
  methods: {
    closeModal() {
      bus.$emit("closeAppModal", close);
    },
  },
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 20px;
}

.language-btn-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.close-instruction {
  display: flex;
  justify-content: flex-end;
}
</style>
